import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axios } from 'lib/axios';
import { listParams, qnaKey } from './queryKeys';

const getPublished = (resource, id, paging) =>
  axios.get(`/api/${resource}/${id}/qna/published`, { params: listParams(paging) });

export const usePublished = (resource, id, paging, options = {}) =>
  useQuery({
    queryKey: qnaKey(resource, id, 'published', paging.page, paging.pageSize, paging.order),
    queryFn: () => getPublished(resource, id, paging),
    select: ({ data }) => ({ items: data.data, total: data.total }),
    placeholderData: keepPreviousData,
    ...options,
  });
